var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgS2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_887_7848)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.46484 36.8998V4.59961C1.46484 3.70508 1.83984 2.89844 2.44141 2.32617C3.00391 1.79297 3.76367 1.46484 4.59961 1.46484H95.4004C97.1309 1.46484 98.5352 2.86914 98.5352 4.59961V95.4004C98.5352 97.1309 97.1309 98.5352 95.4004 98.5352H4.59961C2.86914 98.5352 1.46484 97.1309 1.46484 95.4004V44.2871",
    stroke: "#012060",
    strokeWidth: 2.92969,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50 82.6035V44.2871H98.5352V95.4004C98.5352 97.1309 97.1309 98.5352 95.4004 98.5352H50V89.5457",
    stroke: "#012060",
    strokeWidth: 2.92969,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.6564 23.4865L98.5352 44.2871H50L2.44141 2.32617C3.00391 1.79297 3.76367 1.46484 4.59961 1.46484H69.9629L80.8639 17.8025",
    stroke: "#012060",
    strokeWidth: 2.92969,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.1779 44.2871L24.2969 1.46484",
    stroke: "#012060",
    strokeWidth: 2.92969,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.3561 44.2871L47.1289 1.46484",
    stroke: "#012060",
    strokeWidth: 2.92969,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8301 15.9048H79.5961",
    stroke: "#012060",
    strokeWidth: 2.92969,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9824 30.1541H89.1059",
    stroke: "#012060",
    strokeWidth: 2.92969,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_887_7848"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgS2);
export default __webpack_public_path__ + "static/media/s2.7196a9a6a0e1c0dc509c72f0236c09bf.svg";
export { ForwardRef as ReactComponent };